var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstruction4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_238",
    "data-name": "Group 238",
    xmlns: "http://www.w3.org/2000/svg",
    width: 747.28,
    height: 462.177,
    viewBox: "0 0 747.28 462.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      :root {\n      --primary-color: #9138b0;\n      --secondary-color: #D9B0EA;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_377",
    width: 747.28,
    height: 462.177,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_370",
    width: 37.313,
    height: 33.525,
    transform: "translate(279.074 117.602)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_371",
    width: 38.416,
    height: 32.758,
    transform: "translate(436.309 250.268)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_374",
    width: 90.983,
    height: 129.366,
    transform: "translate(262.976 184.306)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    width: 102.536,
    height: 120.896,
    transform: "translate(378.151 103.816)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_366",
    width: 742.281,
    height: 457.177,
    rx: 36.218,
    transform: "translate(2.5 2.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    width: 684.796,
    height: 390.001,
    rx: 27.595,
    transform: "translate(31.242 36.088)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    cx: 217.065,
    cy: 23.704,
    rx: 217.065,
    ry: 23.704,
    transform: "translate(164.527 352.21)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    d: "M598.657,364.474c0,13.092-97.183,23.7-217.065,23.7s-217.065-10.612-217.065-23.7,97.183-23.7,217.065-23.7,217.065,10.612,217.065,23.7",
    fill: "var(--primary-color)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_12",
    cx: 217.065,
    cy: 23.704,
    rx: 217.065,
    ry: 23.704,
    transform: "translate(164.527 340.77)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    d: "M394.029,364.349a13.406,13.406,0,1,1-13.406-13.406",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    width: 11.157,
    height: 11.157,
    transform: "translate(384.809 349.629)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    width: 11.157,
    height: 11.157,
    transform: "translate(378.044 355.207)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    d: "M301.9,150.127s-3.75-15.509-21.23-13.285",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    d: "M314.3,140.556a27.008,27.008,0,0,1,1.086-19.381",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    d: "M295.784,127.739s-7-6.138-15.71-4.489",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    d: "M304.751,136.6s-2.689-12.634,1.224-18",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    d: "M454.342,282.026s1.762-15.859,19.383-15.859",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    d: "M440.833,274.1a27.011,27.011,0,0,0-3.524-19.089",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    d: "M457.584,259.045s6.168-6.973,15.018-6.436",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    d: "M449.807,268.967s1.073-12.872-3.486-17.7",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    d: "M423.985,220.024a57.758,57.758,0,1,1-57.759-57.759",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    width: 48.069,
    height: 48.069,
    transform: "translate(384.263 156.602)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_373",
    width: 48.069,
    height: 48.069,
    transform: "translate(355.116 180.637)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    d: "M266.351,185.306s-24.907,126.8,86.609,127.366",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    d: "M379.151,104.837s107.534-4.528,100.175,118.875",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstruction4);
export default __webpack_public_path__ + "static/media/instruction4.93dedaead99eb669c327febce8d7e459.svg";
export { ForwardRef as ReactComponent };